"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resourcePlugin = resourcePlugin;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _reduxActions = require("redux-actions");

var _constants = require("../constants");

var _language = require("../utilities/language");

var _mutators = require("../utilities/mutators");

var _introspection = require("../utilities/introspection");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {}; // eslint-disable-next-line import/prefer-default-export

function resourcePlugin(resourceType, options) {
  var _handleActions;

  return (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _constants.actionTypes.UPDATE_RESOURCES, {
    next: function next(previousState, action) {
      var list = (0, _introspection.getResourceListByType)(action, resourceType);
      var metadata = (0, _introspection.getResourceMetadataByType)(action, resourceType);
      var resources = (0, _introspection.getResourcesByType)(action, resourceType);

      if ((0, _language.isNil)(list) && (0, _language.isNil)(metadata) && (0, _language.isNil)(resources)) {
        return previousState;
      }

      var previousResources = previousState.resources,
          previousMetadata = previousState.metadata,
          previousLists = previousState.lists;
      var idAttribute = options.idAttribute;
      var nextResources = previousResources;
      var nextLists = previousLists;
      var nextMetadata = previousMetadata;

      if (!(0, _language.isNil)(list)) {
        nextLists = (0, _keys.default)(list).reduce(function (previousValue, listName) {
          return _objectSpread(_objectSpread({}, previousValue), {}, (0, _defineProperty2.default)({}, listName, list[listName]));
        }, previousLists);
      }

      if (!(0, _language.isNil)(resources)) {
        nextResources = (0, _mutators.upsertResources)({
          previousResources: previousResources,
          resources: resources,
          idAttribute: idAttribute,
          mergeResources: (0, _introspection.getMergeResources)(action, resourceType)
        });
      }

      if (!(0, _language.isNil)(metadata)) {
        nextMetadata = (0, _mutators.upsertMetadata)({
          previousMetadata: previousMetadata,
          metadata: metadata,
          mergeMetadata: (0, _introspection.getMergeMetadata)(action, resourceType)
        });
      }

      return _objectSpread(_objectSpread({}, previousState), {}, {
        resources: nextResources,
        metadata: nextMetadata,
        lists: nextLists
      });
    }
  }), (0, _defineProperty2.default)(_handleActions, _constants.actionTypes.DELETE_RESOURCES, {
    next: function next(previousState, action) {
      var resources = (0, _introspection.getResourcesByType)(action, resourceType);

      if ((0, _language.isNil)(resources)) {
        return previousState;
      }

      var idAttribute = options.idAttribute;
      var previousResources = previousState.resources,
          previousLists = previousState.lists;
      var nextResources = previousResources;
      var nextLists = previousLists;

      if (!(0, _language.isNil)(resources)) {
        nextResources = (0, _mutators.deleteResources)({
          previousResources: previousResources,
          resources: resources,
          idAttribute: idAttribute
        });
        nextLists = (0, _keys.default)(previousLists).reduce(function (previousValue, listName) {
          return _objectSpread(_objectSpread({}, previousValue), {}, (0, _defineProperty2.default)({}, listName, previousValue[listName].filter(function (resource) {
            return resources.indexOf(resource) === -1;
          })));
        }, previousLists);
      }

      return _objectSpread(_objectSpread({}, previousState), {}, {
        resources: nextResources,
        lists: nextLists
      });
    }
  }), _handleActions), initialState);
}